import script from "./IntegrationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationPage.vue?vue&type=script&setup=true&lang=js"

import "./IntegrationPage.vue?vue&type=style&index=0&id=201b7d5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201b7d5e"]])

export default __exports__